<div class="slide-down" id="message_wrapper">
  <div
    class="slide-down jaguarFont"
    id="message_div"
    (click)="removeMsg()"
  ></div>
  <div class="slide-down jaguarFont" id="flag_div" (click)="removeFlag()"></div>
</div>
